/**
 * Please include...
 * - Test key (all caps)
 * - Test name (as it appears in TNL)
 * - Jira ticket to clean up the test after it runs
 */
const TESTS = {
    HOUSERULESV2UPDATE: 'HouseRulesV2Update', // https://jira.expedia.biz/browse/VCHK-11570
    HA_BOT_PROPERTYDETAILS_WEB_V1: 'HA_BOT_PropertyDetails_Web_v1',
    HA_BOT_PROPERTYDETAILSVALAUNCH_V2: 'HA_BOT_PropertyDetailsVALaunch_v2',
    HA_BOT_Recommendations_V1: 'HA_BOT_Recommendations_V1',
    HA_BOT_WEB_BEDMAPSPRICERULES: 'HA_BOT_Web_BedMapsPriceRules',
    HA_GDPR_BANNER: 'ha_gdpr_banner',
    HA_IDA_PDP_GOOGLEONETAP: 'HA_IDA_PDP_GOOGLEONETAP',
    HA_PULSE_CLOSE_SAVE_MODAL: 'ha_pulse_close_save_modal', // (41796) https://jira.expedia.biz/browse/FRIENDS-4245
    HA_PULSE_SELECTABLE_BOARD_TITLE: 'ha_pulse_selectable_board_title', // https://jira.expedia.biz/browse/FRIENDS-4173: cleanup
    HA_GX_PRE_BRAND_TRANSITION: 'HA_GX_PRE_BRAND_TRANSITION',
    HA_GX_POST_BRAND_TRANSITION: 'HA_GX_POST_BRAND_TRANSITION',
    HA_TYPEAHEAD_LID_SEARCH: 'HA_TYPEAHEAD_LID_SEARCH',
    HA_TYPEAHEAD_TWO_LINE_DISPLAY: 'ha_typeahead_two_line_display_v2',
    MESO_VRBO_DISPLAY_ADS: 'MESO_Vrbo_display_ads',
    VRBO_MESO_HOUSE_ADS: 'VRBO_MeSo_HouseAds', // https://jira.expedia.biz/browse/VRBOADS-53
    VRBO_AFFIRM_NO_PREQUAL: 'Vrbo_Affirm_noPrequal',
    HA_PTA_HEADER_LOGIN_COPY: 'HA_PTA_HEADER_LOGIN_COPY',
    HA_PDP_VIRTUAL_TOUR_HELPFULNESS: 'HA_PDP_virtual_tour_helpfulness',
    HA_VT_DIRECT_NAVIGATION: 'HA_VT_Direct_Navigation',
    HA_PTA_SEARCHFORM_DATES_NUMBER_OF_NIGHTS_SUMMARY:
        'HA_PTA_SEARCHFORM_datesnumberOfNightsSummary',
    VRBO_WEB_GLOBAL_MESSAGING_BANNER: 'vrbo_web_global_messaging_banner',
    HA_TRAVELER_HEADER_TRAY_MOBILE_APP: 'HA_TRAVELER_HEADER_TRAY_MOBILE_APP',
    PDP_PRICE_TRANSPARENCY_REDESIGN_MWEB: 'pdp_price_transparency_redesign_mweb', // https://jira.expedia.biz/browse/OFFERS-2226
    ADD_SCROLL_TO_PDP_PRICE_DISPLAY: 'add_scroll_to_pdp_price_display', // https://jira.expedia.biz/browse/OFFERS-968
    HA_PTA_SEARCHBOX_HINT_TEXT_CHOOSING_DATES: 'HA_PTA_SEARCHBOX_hintTextChoosingDates',
    VRBO_LANDING_ARIA_ROLES_ON_SEARCHFORM: 'VRBO_LANDING_ARIArolesOnSearchForm',
    VRBO_LANDING_COLLAPSED_PDP_SF_CTA_V2: 'VRBO_LANDING__collpased_PDP_SF_CTA_v2', // https://jira.expedia.biz/browse/SHCMP-2424
    VRBO_LANDING_EGUAS_TYPEAHEAD: 'VRBO_LANDING_EGUAS_typeahead', // 41009 Clean up: https://jira.expedia.biz/browse/SHCMP-2356
    VRBO_LANDING_EXPANDED_SEARCHFORM_ON_PDP: 'VRBO_LANDING_expandedSearchFormOnPDP',
    VRBO_LANDING_NEARBY_DESTINATIONS: 'VRBO_LANDING_nearbyDestinations_EGReco', // https://jira.expedia.biz/browse/SHCMP-2419
    VRBO_LANDING_SCALE_HINTTEXT_WHEN_CHOOSING_DATES: 'VRBO_LANDING_scale_HintTextWhenChoosingDates', // https://jira.expedia.biz/browse/SHCMP-2203
    VRBO_LANDING_SCALE_LAUNCH_SEARCH_FROM_GUESTPICKER:
        'VRBO_LANDING_scale_launchSearchFromGuestPicker',
    VRBO_LANDING_DESTINATIONLESS_ERROR_ON_SEARCHFORM:
        'VRBO_LANDING_DestinationlessErrorOnSearchForm', // https://jira.expedia.biz/browse/SHCMP-2137
    VRBO_LANDING_SEARCHFORM_DATEPICKER_DAY_OF_WEEK: 'VRBO_LANDING_searchFormDatepickerDayOfWeek', // https://jira.expedia.biz/browse/SHCMP-2238
    VRBO_LANDING_SEARCHFORM_DATE_FORMAT: 'VRBO_LANDING_searchFormDateFormat', // https://jira.expedia.biz/browse/SHCMP-2195
    VRBO_LANDING_PROPERTY_HERO_IMAGE_SELECTION: 'Vrbo_landing_propertyheroimageselection', // 39320 | https://jira.expedia.biz/browse/VGT-9108
    VRBO_WEB_PDP_OPTIMIZE_AMENITIES: 'vrbo_web_PDP_optimize_amenities_V2', // https://jira.expedia.biz/browse/VRBOSHOP-2450
    VRBO_LANDING_UPDATED_BREADCRUMB_SEO: 'VRBO_LANDING_UpdatedBreadcrumbSEOTest2', // 40621 | https://jira.expedia.biz/browse/VGT-9475
    VRBO_WEB_PDP_REPORTING_CONTENT_PILOT: 'vrbo_web_pdp_reporting_content_pilot', // 42526 | https://jira.expedia.biz/browse/VRBOSHOP-4240
    HA_NATIVE_ADOPTION_PLACEMENT_HEADER: 'HA_NATIVE_ADOPTION_PLACEMENT_HEADER',
    VRBO_WEB_PDP_OPTIMIZE_REVIEWS: 'Vrbo_web_pdp_optimize_reviews', // 42938 | https://jira.expedia.biz/browse/VRBOSHOP-4306
    VRBO_IPM_STATIC_MESSAGING: 'vrbo_ipm_static_messaging', // 43248 https://jira.expedia.biz/browse/SE-6049
    VRBO_HEADER_DESKTOP_PERMANENT_MAD_PLACEMENT: 'Vrbo_Header_Desktop_permanent_MAD_placement', // 43723  https://jira.expedia.biz/browse/PROCOM-1915
    VRBO_STAR_RATING_HEADER_BANNER: 'Vrbo_star_rating_header_banner' // 44101  https://jira.expedia.biz/browse/WNAT-587
};

const EVALUATE = Object.values(TESTS);
const EVALUATE_AND_LOG = [];

module.exports = {
    EVALUATE,
    EVALUATE_AND_LOG,
    ...TESTS
};
